import { stringify } from 'query-string';

import { ESearchFilters } from '@/constants/searchFilters';
import { WISHLISTS_RECENTLY_SAVED } from '@/constants/urls';
import apiRequest from '@/services/apiRequest';
import { getCoreApi, getSearchApi } from '@/utility/getCoreApi';

import { ERentalCategory, IData } from './types/search/rentals/id';

export const wishlistsRecentlySavedRequest = async (
  currency?: string,
  locale?: string,
  rentalCategory?: ERentalCategory,
) => {
  const params: Record<string, string | undefined> = { rental_category: rentalCategory };
  const url = `${getCoreApi()}${WISHLISTS_RECENTLY_SAVED}?${stringify(params)}`;
  const response = await apiRequest<number[]>(
    {
      url,
    },
    true,
    true,
  );

  // If we receive just IDs, we need to fetch the full rental details
  if (response?.data && Array.isArray(response.data)) {
    // If the response contains only IDs (numbers), fetch full rental details
    if (response.data.length > 0 && typeof response.data[0] === 'number') {
      // Fetch full rental details for these IDs
      const searchParams: Record<string, string | boolean | undefined> = {
        [ESearchFilters.IDS]: response.data.join(','),
        [ESearchFilters.RAW_JSON]: true,
        mini: 'true',
        currency,
        locale,
      };

      if (rentalCategory) searchParams[ESearchFilters.RENTAL_CATEGORY] = rentalCategory;

      const rentalsData = await apiRequest<{ data: IData[] }>(
        {
          url: `${getSearchApi()}/rentals?${stringify(searchParams)}`,
        },
        true,
      );

      return rentalsData?.data;
    }

    // If the response already contains full rental objects, just return them
    return response.data as unknown as IData[];
  }

  return [];
};
